import currentUserModule from "./currentUserModule"
import currentUserView from "./currentUserView.html"

currentUserModule.directive("nlgCurrentUser", ()=>{
    return {
        restrict: "E",
        template: currentUserView,
        controller: "currentUserController"
    }
})